<template>
  <div class="min-h-screen">
    <FramePage v-if="view === 'frame'" :frame-id="numericId" />
    <NotebookIndex v-else-if="view === 'notebooks'" />
    <NotebookPage v-else-if="view === 'notebook'" :key="String(id)" :notebook-id="String(id)" />
    <NotebookReport v-else-if="view === 'report'" :key="String(id)" :notebook-id="String(id)" />
    <div v-else-if="view === 'frames'">
      <PageHeader title="Saved frames" subtitle="Immutable tables kept by name: uploads and results kept from notebooks" :breadcrumbs="BASE_CRUMBS" />
      <div class="p-6 pb-32"><SavedFrameCatalog /></div>
    </div>
  </div>
</template>

<script>
import FramePage from './FramePage.vue';
import NotebookIndex from './NotebookIndex.vue';
import NotebookPage from './NotebookPage.vue';
import NotebookReport from './NotebookReport.vue';
import SavedFrameCatalog from '@/components/ETL_Utility/SavedFrameCatalog.vue';
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue';
import { BASE_CRUMBS } from './impactNav';

export default {
  name: 'ImpactAnalytics',
  components: { FramePage, NotebookIndex, NotebookPage, NotebookReport, SavedFrameCatalog, PageHeader },
  props: {
    view: { type: String, default: 'notebooks' },
    id: { type: [Number, String], default: null },
  },
  data() {
    return { BASE_CRUMBS };
  },
  computed: {
    numericId() {
      return this.id == null ? null : Number(this.id);
    },
  },
};
</script>
